<template>
  <section id="previous-donations-section" class="section-scc-portal container">
    <form class="form-box-shadow" id="form-previous-donations-portal-scc">
      <div class="row container-block items-row-my-donations">
        <div class="col-md-6 ">
          <h2 id="your-blood-my-donation" style="display: flex; align-items: center;">Your Blood Type:
            <span style="font-size: 40px; color: #D90000; margin-left: 10px;">
              {{ bloodType }}
            </span></h2>
        </div>
        <div class="col-md-6">

<!--
          <h2 id="available-reward-points" style="display: flex; align-items: center;">
            Available Reward Points: {{ freePoints }}
          </h2>
-->

          <div
            class="container-block"
            v-for="(itemDonorCharacteristics, indexDonorCharacteristics) in donorCharacteristics"
            :key='indexDonorCharacteristics'
          >
            <h3>
              {{ itemDonorCharacteristics.name }} (itemDonorCharacteristics.date)))
            </h3>
          </div>
        </div>
        <div class="container-item-tabl container-block  life-time-donation">
          <h3 class="">Your Lifetime Donations (units)</h3>
          <div class="row" id="block-link-donate-blood container-block" style="padding: 0 15px;">
            <div
              class="col container-eligibility"
              v-for="(itemSumProcedure, indexSumProcedure) in sumProcedure" :key="indexSumProcedure"
              style="min-width: 140px;"
            >
              {{ itemSumProcedure.nameProcedure }} : {{ itemSumProcedure.sum }}
            </div>
          </div>
        </div>
        <div class="container-item-tabl container-block">
          <h3>Your Most Recent Donation <span style="font-size: 14px;"> {{ tabMessage }} </span></h3>
          <previous-donation-tab
              :previousDonations = previousDonations
              slice="resentDonation"
          />
        </div>
        <div v-if="previousDonations.length > 1">
          <div class="container-item-tabl">
            <h3>Previous Donations:</h3>
            <previous-donation-tab
                :previousDonations = previousDonations
                :slice="seeFull?'short':'all'"
            />
          </div>
          <a
              id="show-all-history-donor-donations"
              v-if="seeFull"
              v-on:click="seeFull = false"
          >
            All History
          </a>
          <a
              id="show-short-history-donor-donations"
              v-if="!seeFull"
              v-on:click="seeFull = true"
          >
            Short History
          </a>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import {mapState} from "vuex";
import previousDonationTab from "../elements/previousDonationTab";

export default {
  name: "previousDonations",
  components: { previousDonationTab},
  data() {
    return {
      expandTests: {
        iconExpandTests: false,
        expandTests: false,
      },
      seeFull: true,
      sumProcedure: {},
      freePoints: null,
      tabMessage: '',
    }
  },
  computed: {
    ...mapState({
      previousDonations: state => state.donorInformation.previousDonation,
      bloodType: state => state.donorInformation.bloodType,
      donorCharacteristics: state => state.donorInformation.donorCharacteristics,
      arrCreateTab: state => state.settingsAndCustomize.siteCustomizationData.previousDonations.arrCreateTab,
      lifetimeDonations: state => state.donorInformation.lifetimeDonations,
    })
  },
  watch: {
  },
  async mounted() {
    this.$root.$emit("showSpinner");
    const response = await this.$store.dispatch('settingsAndCustomize/SET_getPreviousDonation')
    const responseTotalSum = await this.$store.dispatch('settingsAndCustomize/SET_getTotalLifeTimeDonations')
    this.sumProcedure = await this.$store.dispatch('donorInformation/SET_donorPreviousDonate', {
      previousDonate: response,
      totalSum: responseTotalSum,
    })

    this.tabMessage = this.$store.getters["settingsAndCustomize/messages"]('prevDonationPreTabName')

    this.freePoints = this.$store.getters["donorInformation/pointsTotal"]-this.$store.getters["donorInformation/sumRewardsPoints"]
    this.freePoints = this.freePoints>0?this.freePoints:0

    this.$root.$emit("hideSpinner");
  },
  methods: {
    getArrCreateTabLength() {
      return Object.keys(this.arrCreateTab).length
    },
    hideTests(){
      this.expandTests.iconExpandTests = false
      this.expandTests.expandTests = false
    },
    showTests(){
      this.expandTests.iconExpandTests = true
      this.expandTests.expandTests = true
    },
  }
}

</script>
<style scoped>
  .life-time-donation{
    margin: 30px 0;
  }
  .container-eligibility{
    padding: 0.5rem 0.5rem;
    border-color: rgb(222, 226, 230);
    border-style: solid;
    border-width: 1px;
  }
</style>
